import React from "react";

import {
  Card,
  CardBody,
  Row,
  Col,
  Button,
  Alert
} from "reactstrap";
import { Textbox, Checkbox } from "react-inputs-validation";
import "../../styles/estilos.css";
import { withRouter } from "react-router-dom";

import { connect } from "react-redux";
import { setCorreo } from "../../redux/actions/aCotizacion";
import { limpiarTotalesHogar } from "../../redux/actions/ACarritoProductos";

class ValoresCotizacionHogar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      correo: "",
      visibleAlert: true,
      terminosHabilitado: this.props.paso === "confirmacion-cotizacion" ? false : true,
      height: window.innerHeight,
      claseDivFix: "flex-row div-flotante",
      validate: false,
      hasCorreoError: true,
    }
    this.handleScroll = this.handleScroll.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    this.setState({ visibleAlert: false });
  }

  editarForm = (formEditado) => {
    this.setState({ formEditado });
  }



  onClick = async (event) => {
    event.preventDefault();
    if (this.props.paso === "valores-cotizacion") {
      this.props.metodo();
    }
    else if (this.props.paso === "resumen-cotizacion") {
      this.props.metodo();
    }
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  onClickEnviar = (correo) => {
    this.toggleValidating(true);
    let { hasCorreoError } = this.state
    if (hasCorreoError === false) {
      this.props.metodoEnviar(correo);
    }
  }

  onChangeCorreo = (event) => {
    event.preventDefault();
    this.setState({
      correo: event.target.value
    })
  }

  /* Eventos Scroll */
  handleScroll() {
    const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
    const windowBottom = windowHeight + window.pageYOffset;
    if (this.props.paso === "resumen-cotizacion") {
      if (this.props.detalleCarrito && this.props.detalleCarrito.productosCarrito.carProductos.length > 1) {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen-multi'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
      else {
        if (windowBottom >= (docHeight - 300)) {
          this.setState({
            claseDivFix: 'flex-row div-flotante fix-botton-totales-resumen'
          });
        } else {
          this.setState({
            claseDivFix: 'flex-row div-flotante'
          });
        }
      }
    }
    else {
      if (windowBottom >= (docHeight - 120)) {
        this.setState({
          claseDivFix: 'flex-row div-flotante fix-botton-totales'
        });
      } else {
        this.setState({
          claseDivFix: 'flex-row div-flotante'
        });
      }
    }
  }

  async componentDidMount() {
    await this.props.limpiarTotalesHogar();
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  render() {
    let { datosCarritoHogar, formEditado, esAdvance, esHogarAdvance, cargarTotalesRecuperado, habilitarBotonContinuar, correoAlert, msgValidarPantallaFacturacion, msgValidarPantallaFacturacionActualizar } = this.props;

    console.log('datosCarritoHogar2020', datosCarritoHogar.setCarritoHogar.valorTotal)
    if (datosCarritoHogar.setCarritoHogar && datosCarritoHogar.setCarritoHogar.valorTotal) {

    }
    const { terminosHabilitado, claseDivFix, correo, validate, hasCorreoError } = this.state;
    let total = {
      prima_neta_anual_full_cobertura: "0.00",
      super_bancos_Full_Cobertura: "0.00",
      seguro_campesino_Full_Cobertura: "0.00",
      derecho_emision_Full_Cobertura: "0.00",
      primaTotal_Full_Cobertura: "0.00",
      iva_Full_Cobertura: "0.00",
      totalImpuestos: "0.00"
    }

    //Verificar si los datos son de un formulario nuevo o son provinientes de una recuperacion de cotizacion
    if (!cargarTotalesRecuperado) {

      if (datosCarritoHogar.setCalculoPrimaHogar !== undefined && datosCarritoHogar.setCalculoPrimaHogar.totales !== undefined) {


        if (esHogarAdvance) {

          if (datosCarritoHogar.setCarritoHogar.valorTotal) {
            total.prima_neta_anual_full_cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.prima_neta_anual_full_cobertura
            total.primaTotal_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.totalcarrito
            total.super_bancos_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.super_bancos_Full_Cobertura
            total.seguro_campesino_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.seguro_campesino_Full_Cobertura
            total.derecho_emision_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.derecho_emision_Full_Cobertura
            total.iva_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.iva_Full_Cobertura
            total.totalImpuestos = datosCarritoHogar.setCarritoHogar.valorTotal.totalImpuestos
          }



        } else {
          total.prima_neta_anual_full_cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.PrimaNeta
          total.primaTotal_Full_Cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.primaTotal
          total.super_bancos_Full_Cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.impuestos_superBancos
          total.seguro_campesino_Full_Cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.impuestos_SegCampesino
          total.derecho_emision_Full_Cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.impuestos_derechosEmision
          total.iva_Full_Cobertura = datosCarritoHogar.setCalculoPrimaHogar.totales.impuestos_iva
          total.totalImpuestos = datosCarritoHogar.setCalculoPrimaHogar.totales.impuestosTotales
        }

      }
    }
    else {
      if (datosCarritoHogar.setCarritoHogar !== undefined && datosCarritoHogar.setCarritoHogar.valorTotal !== undefined) {
        if (this.props.paso === "valores-cotizacion") {
          total.prima_neta_anual_full_cobertura = datosCarritoHogar.setProductoActualHogar.totales.prima_neta_anual_full_cobertura
          total.primaTotal_Full_Cobertura = datosCarritoHogar.setProductoActualHogar.totales.primaTotal_Full_Cobertura
          total.super_bancos_Full_Cobertura = datosCarritoHogar.setProductoActualHogar.totales.super_bancos_Full_Cobertura
          total.seguro_campesino_Full_Cobertura = datosCarritoHogar.setProductoActualHogar.totales.seguro_campesino_Full_Cobertura
          total.derecho_emision_Full_Cobertura = datosCarritoHogar.setProductoActualHogar.totales.derecho_emision_Full_Cobertura
          total.iva_Full_Cobertura = datosCarritoHogar.setProductoActualHogar.totales.iva_Full_Cobertura
          total.totalImpuestos = datosCarritoHogar.setProductoActualHogar.totales.totalImpuestos
        }
        else {

          total.prima_neta_anual_full_cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.prima_neta_anual_full_cobertura
          total.primaTotal_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.totalcarrito
          total.super_bancos_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.super_bancos_Full_Cobertura
          total.seguro_campesino_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.seguro_campesino_Full_Cobertura
          total.derecho_emision_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.derecho_emision_Full_Cobertura
          total.iva_Full_Cobertura = datosCarritoHogar.setCarritoHogar.valorTotal.iva_Full_Cobertura
          total.totalImpuestos = datosCarritoHogar.setCarritoHogar.valorTotal.totalImpuestos


        }

      } else {





      }
    }
    //Validaciones de texto de boton
    let textoBoton = " CONTINUAR";
    let claseBoton = "btn btn-primary";
    if (formEditado) {
      textoBoton = "ACTUALIZAR";
      claseBoton = "btn btn-primary btn-purple fe-pulse";
    }

    //Fin Validaciones de texto de boton
    return (
      <Card className={claseDivFix}>
        <CardBody>
          <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>Prima Neta</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <h5>${total.prima_neta_anual_full_cobertura}</h5>
            </Col>
          </Row>
          <Row>
            <div id="container-imp">
              <div className="accordion-imp">
                <input type="checkbox" id="tm" />
                <label htmlFor="tm" className="accordionitem">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5 title={"Presiona click para ver/ocultar el detalle impuestos"} >
                        Impuestos{" "}
                        <i
                          className="fa fa-info-circle"
                          aria-hidden="true"
                        />
                      </h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.totalImpuestos}</h5>
                    </Col>
                  </Row>
                </label>
                <div className="hiddentext ocultar">
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>IVA</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.iva_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Super bancos 3.5 %</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.super_bancos_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Seguro Campesino</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.seguro_campesino_Full_Cobertura}</h5>
                    </Col>
                  </Row>
                  <Row>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>Derechos de Emisión</h5>
                    </Col>
                    <Col lg={6} md={6} sm={6} xs={6}>
                      <h5>${total.derecho_emision_Full_Cobertura}</h5>
                    </Col>
                  </Row>

                </div>

              </div>
            </div>
          </Row>
          <Row>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>Prima Total</h5>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6}>
              <p />
              <h5 style={{ fontWeight: "bold" }}>${total.primaTotal_Full_Cobertura}</h5>
            </Col>
          </Row>
          <hr />

          {this.props.paso === "valores-cotizacion" &&
            <Button
              className={claseBoton}
              onClick={this.onClick}
              style={{ display: "block", margin: "auto" }}
              disabled={habilitarBotonContinuar}
            >
              <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
              {textoBoton}
            </Button>}
          <p></p>
          {this.props.paso === "valores-cotizacion" && habilitarBotonContinuar && this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima &&
            <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
              <center><p>{this.props.datosCarritoHogar.setCarritoHogar.msgValorLimitePrima}</p></center>
            </Alert>
          }

          {this.props.paso === "resumen-cotizacion" &&
            <div>
              <Button
                className={claseBoton}
                onClick={this.onClick}
                style={{ display: "block", margin: "auto" }}
                disabled={false}
              >
                <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                {" INICIAR EMISIÓN"}
              </Button>

              <p></p>
              {msgValidarPantallaFacturacion &&
                <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                  <p>
                    <div dangerouslySetInnerHTML={{ __html: this.props.datosCarritoHogar.setCarritoHogar.msgcontinuarDatosFacturacion ? this.props.datosCarritoHogar.setCarritoHogar.msgcontinuarDatosFacturacion : "" }} />
                  </p>
                </Alert>
              }
              {msgValidarPantallaFacturacionActualizar &&
                <Alert color="warning" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                  <p>
                    <div dangerouslySetInnerHTML={{ __html: this.props.datosCarritoHogar.setCarritoHogar.msgcontinuarDatosFacturacionActualizar ? this.props.datosCarritoHogar.setCarritoHogar.msgcontinuarDatosFacturacionActualizar : "" }} />
                  </p>
                </Alert>
              }
              <p></p>
              {this.props.datosCarritoHogar.setCarritoHogar && this.props.datosCarritoHogar.setCarritoHogar.carUrlPdf &&
                <div style={{ paddingTop: "1em" }}><a href={this.props.datosCarritoHogar.setCarritoHogar.carUrlPdf} target="_blank" rel="noopener noreferrer">
                  <Button className="btn btn-detail-white" onClick={this.onClickDescargar}>
                    <i className="fa fa-cloud-download" aria-hidden="true" /> DESCARGAR COTIZACIÓN
                  </Button>
                </a></div>
              }
              <p></p>
              {this.props.dataUsuario.usu_tipo_usuario !== "cliente" &&
                <Row>

                  <Col lg={8} md={12} sm={12} xs={12}>
                    {/* <input className="form-control" placeholder="Por favor ingrese el correo" value={correo} onChange={this.onChangeCorreo}>
                            </input> */}


                    <Textbox
                      tabIndex="1"
                      type="input"
                      value={correo}
                      name="correo"
                      id="correo"
                      placeholder="Por favor ingrese el correo"
                      classNameInput={"form-control"}
                      onChange={(correo, e) => {
                        this.setState({ correo: correo });
                      }}
                      validate={validate}
                      validationCallback={res => this.setState({ validate: !res, hasCorreoError: res })} // Optional.[Func].Default: none. Return the validation result.
                      onBlur={e => this.setState({ blur: true })}
                      // Optional.[Func].Default: none. In order to validate the value on blur, you MUST provide a function, even if it is an empty function. Missing this, the validation on blur will not work.
                      validationOption={{
                        name: "correo", // Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                        check: true, // Optional.[Bool].Default: true. To determin if you need to validate.                                
                        required: true,
                        reg: /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/, //Optional.[Bool].Default: "" Custom regex.                                    
                        msgOnError: "Debe ingresar un correo válido" // Optional.[Bool].Default: true. To determin if it is a required field.
                      }}

                    />

                  </Col>
                  <Col lg={4} md={12} sm={12} xs={12}>
                    <Button className="btn btn-detail-white" onClick={() => this.onClickEnviar(correo)} disabled={validate ? !validate : false} >
                      <i className="fa fa-paper-plane-o" aria-hidden="true" /> ENVIAR
                    </Button>

                  </Col>
                  {correoAlert &&
                    <Alert color="success" isOpen={this.state.visibleAlert} toggle={this.onDismiss}>
                      <center><p>Se ha enviado correctamente la cotización al correo electrónico ingresado.</p></center>
                    </Alert>
                  }
                </Row>

              }
            </div>

          }

        </CardBody>
      </Card>
    );
  }
}

const mapStateToProps = state => ({

  datosCarritoHogar: state.datosCarritoHogar,
  dataUsuario: state.datosUsuarios.dataUsuario,
});

const mapDispatchToProps = dispatch => {
  return {
    limpiarTotalesHogar: () => dispatch(limpiarTotalesHogar()),

  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ValoresCotizacionHogar)
);
